import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Projections for Expressions",
description: "Define clean editor projections for expression concepts in Freon, add triggers and reference shortcuts, and assign symbols to binary and comparison expressions.",
tags: [ "Freon", "expressions", "projections", "GradeScore", "QuestionReference", "referenceShortcut", "trigger", "NrOfCorrectAnswers", "NumberLiteralExpression", "binary expressions", "AND", "OR", "comparisons", "editor", "tutorial"] ,
modifiedTime: "2025-11-07T17:20:18.626Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};